import '../styles/Experience.css'
function Experience() {
    return (
        <div className="container">
            <div className="exp-box">
                <div className="item-box">
                    <h1>HTML, CSS, JavaScript</h1>
                </div>
                <div className="item-box">
                    <h1>ReactJS</h1>
                </div>
                <div className="item-box">
                    <h1>Bootstrap</h1>
                </div>
                
                <div className="item-box">
                    <h1>Git</h1>
                </div>
                <div className="item-box">
                    <h1>Python</h1>
                </div>
                <div className="item-box">
                    <h1>Django</h1>
                </div>
            </div>
        </div>
    )
}

export default  Experience